import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  inputMode?: "text" | "email" | "tel" | "url" | "numeric" | "decimal" | "search";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputMode, ...props }, ref) => {
    // Auto-determine inputMode based on type if not specified
    const determinedInputMode = inputMode || (
      type === "email" ? "email" :
      type === "tel" ? "tel" :
      type === "url" ? "url" :
      type === "number" ? "numeric" :
      type === "search" ? "search" :
      undefined
    );

    return (
      <input
        type={type}
        inputMode={determinedInputMode}
        className={cn(
          "flex h-11 w-full rounded-lg border border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 transition-colors duration-150",
          // Mobile-optimized: 16px prevents iOS zoom
          "text-[16px]",
          // Desktop: smaller text
          "md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
